@if (length > 0) {
	@if (isSingle) {
		<!-- SINGLE -->
		@if (isLoading) {
			<ngx-skeleton-loader
				class="flex"
				[style.height]="internalSize > 0 ? (size + 'px') : 'inherit'"
				[style.width]="internalSize > 0 ? (size + 'px') : 'inherit'"
				[appearance]="internalSize > 0 ? 'circle' : null"
				[theme]="{ height: '100%', width: '100%' }"
			/>
		}
		@else {
			@if (avatar) {
				<svc-user-avatar
					class="height-inherit width-inherit"
					[info]="avatar"
					[highDefinition]="highDefinition"
					[matTooltip]="avatar.name"
					[matTooltipDisabled]="!showNameTooltip"
					matTooltipPosition="above"
					class="cursor-default"
				/>
			}
			@else {
				@if (fallbackAvatar; as fb) {
					<svc-user-avatar
						class="height-inherit width-inherit cursor-default"
						[info]="fb"
						[highDefinition]="highDefinition"
						[matTooltip]="fb.name"
						[matTooltipDisabled]="!showNameTooltip"
						matTooltipPosition="above"
					/>
				}
				@else {
						<div
						class="height-inherit width-inherit rounded-full bg-gray-200"
						[style.height]="internalSize > 0 ? (size + 'px') : 'inherit'"
						[style.width]="internalSize > 0 ? (size + 'px') : 'inherit'"
						[style.min-height.px]="internalSize > 0 ? size : null"
						[style.min-width.px]="internalSize > 0 ? size : null"
					></div>
				}
			}
		}
	}
	@else {
		<!-- MULTIPLE -->
		@if (isLoading) {
			<div class="flex flex-col items-center flex-shrink-0 basis-1/4">
				<div class="flex -space-x-7">
					@for (i of [].constructor(maxSize ?? 1); track i) {
						<ngx-skeleton-loader  
							class="flex"
							appearance="circle"
							[theme]="{ 'min-height': size + 'px', height: size + 'px', width: size + 'px' }"
						/>
					}
				</div>
			</div>
		}
		@else {
			@if (avatars.length > 0) {
				<svc-avatar-multiple
					class="cursor-default"
					[info]="{ size: size, initialsColor: '#F0F0F0', type: 1, data: avatars }"
					[highDefinition]="highDefinition"
					[max-size]="maxSize"
					[border-color]="borderColor"
				/>
			}
			@else {
				<div
					class="rounded-full bg-gray-200"
					[style.height.px]="size"
					[style.width.px]="size"
					[style.min-height.px]="size"
					[style.min-width.px]="size"
				></div>
			}
		}
	}
}
@if (length <= 0) {
	@if (fallbackAvatar; as fb) {
		<svc-user-avatar
			class="height-inherit width-inherit cursor-default"
			[info]="fb"
			[highDefinition]="highDefinition"
			[matTooltip]="fb.name"
			[matTooltipDisabled]="!showNameTooltip"
			matTooltipPosition="above"
		/>
	}
	@else {
		<div
			class="rounded-full bg-gray-200"
			[style.height]="internalSize > 0 ? (size + 'px') : 'inherit'"
			[style.width]="internalSize > 0 ? (size + 'px') : 'inherit'"
		></div>
	}
}
